
function guuGetUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //
        var r = window.location.search.substr(1).match(reg);  //
        if (r != null) return unescape(r[2]); return null; //
}

 $(document).ready(function() {
   console.log("start tracking");
     var gtrk = guuGetUrlParam("gtrk");
     if(gtrk != null){
       if($.cookie("guu-tracking-key") == undefined){
           var expiresDate= new Date();
          expiresDate.setTime(expiresDate.getTime() + (60*60*12000*60));
         $.cookie('guu-tracking-key', gtrk, { expires: expiresDate, path: '/' });
       }
     }

   var gtrk = guuGetUrlParam("_kx");
      if(gtrk != null){
       // if($.cookie("guu-tracking-key") == undefined){
          var utmid = guuGetUrlParam("utm_id");
           var expiresDate= new Date();
          expiresDate.setTime(expiresDate.getTime() + (60*60*12000*60));
         $.cookie('guu-tracking-key', "klaviyo-campaign_"+(new Date()).toLocaleDateString()+"_"+utmid, { expires: expiresDate, path: '/' });
       // }
     }

   if($.cookie("guu-abtest-stamped") == undefined){
      $.ajax(
          {	type: "POST",
           	async:1,
           	cache:!1,
              url: 'https://app.theguushop.com/getABStamped?_'+(new Date().getTime()),
              success: function(e) {
              console.log(e);
                var expiresDate= new Date();
                expiresDate.setTime(expiresDate.getTime() + (60*60*12000*14));
              	$.cookie('guu-abtest-stamped', e, { expires: expiresDate, path: '/' });
      
              },
              error: function(e, t) {
      
              }
          }
      )
	// var abtest_num = Math.floor(Math.random() * 10 );
	// $.cookie('guu-abtest-stamped', abtest_num, { expires: expiresDate, path: '/' });
    }

   var forceab = guuGetUrlParam("forceab");
     if(forceab != null){
         var expiresDate= new Date();
        expiresDate.setTime(expiresDate.getTime() + (60*60*12000*14));
        $.cookie('guu-abtest-stamped', forceab, { expires: expiresDate, path: '/' });
     }
   
  

  // var showMoissanite = ["0","1","2","5","6","7"];
  // if($.cookie("guu-abtest-stamped") != undefined && showMoissanite.includes(getCookie("guu-abtest-stamped"))){
  //   $(".icon-list-slider").first().find(".item#m-slider-hot").first().after($("#m-slider-moissanite"))
  // }
   
  })
        